import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function Careers() {
    
     const [radiuscareer, setRadiuscareer] = useState([]);
        useEffect(() => {
            const fetchWebsiteInfo = async () => {
                try {
                    let response = await fetch(`https://crmradius.gemsdrive.co.uk/public/api/get_careers`);
                    if (response.ok) {
                        let result = await response.json();
                        setRadiuscareer(result.category || []);
                    } else {
                        console.error("Error fetching website info");
                    }
                } catch (error) {
                    console.error("Error fetching website info:", error);
                }
            };
    
            fetchWebsiteInfo();
        }, []);
        console.log(radiuscareer);

    return (
        <>
            <style type="text/css">
                {` 
                .right-columns p {
                    color: #e5d8d8;
                    line-height: 49px;
                    border-bottom: 1px solid white;
                    margin: 0 0 20px;
                }
                #content_section p,ul,h1{
                    text-align: justify !important;
                }
                .job-post p{
                    color: white !important;
                }
                .border-color-light, .border-light {
                    border-color: #272761 !important;
                }
                .text-pink{
                    color: #E6178B !important;
                }

                .text-blue{
                    color: #272761 !important;
                }
                .nav-tabs li{
                    border-bottom: 1px solid white !important;
                }
                .tab-buttons{
                    border-bottom: 1px solid white !important;
                    background: none !important;
                    border: none !important;
                    border-radius: 0px !important;
                    text-align: 'left';
                }
                .feature-box {
                    min-height: 300px;
                }
                .tab-content{
                    background: unset !important;
                    border-radius: unset !important;
                    border: unset !important;
                    box-shadow: unset !important;
                }                    
               
            `}
            </style>
            <div>
                <Helmet>
                    <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company - Careers</title>
                    <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                    <meta property="og:title" content="Radius - Careers" />
                    <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                </Helmet>

                <Header />
                <main role="main" className="main">
                    {/* <section
                        className="page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-7"
                        style={{
                            backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                        }}
                    >
                        <div className="container">
                            <div className="row mt-5">
                                <div className="col-md-12 align-self-center p-static order-2 text-center">
                                    <h1 className="text-10">
                                        <strong>Careers</strong>
                                    </h1>
                                </div>
                                <div className="col-md-12 align-self-center order-1">
                                    <ul className="breadcrumb breadcrumb-light d-block text-center">

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section> */}
                    <section className="page-header page-header-modern page-header-md bg-transparent m-0">
                        <div className="container mt-5">
                            <div className="row">
                                <div className="col-md-12 align-self-center p-static order-2 text-center mt-5">								
                                    <h1 className="text-dark text-10"><strong>Careers</strong></h1>								
                                    <span className="sub-title text-dark">We're always looking for rockstars</span>							
                                </div>							
                                <div className="col-md-12 align-self-center order-1">
                                    <ul className="breadcrumb d-block text-center">
                                        <li><NavLink to="/home">Home</NavLink></li>
                                        <li className="active">Pages</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
 
                    <div className="container-fluid mt-5 pt-0">
                        <div className="container" style={{ maxWidth: "1200px" }}>
                            <div className="row mb-4">
                                {radiuscareer.map((career) => (
                                    <div className="col-md-6 col-sm-12">
                                        <div className="p-4 card shadow-sm border-2 text-start" style={{ borderBottom: '2px solid #E40074' }}>
                                            {/* Job Title */}
                                            <h3 className="fw-bold text-dark mb-2">{career.job_title}</h3>
                                            {/* Row: Job Type + Apply Button */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="fw-semibold text-secondary mb-0">{career.job_type}</h5>
                                                <NavLink
                                                    to={`/careers-details/${career.slug}`}
                                                    className="btn btn-pink fw-bold btn-sm"
                                                >
                                                    Apply Now
                                                </NavLink>
                                            </div>
                                            {/* Location */}
                                            <div className="d-flex align-items-center">
                                                <i className="fas fa-map-marker-alt me-2 text-primary"></i>
                                                <span className="text-dark fw-semibold">{career.location}</span>
                                            </div>

                                        </div>
                                    </div>
                                ))}
 
                            </div>

                        </div>
                    </div>
                </main>
                <div role="main" className="main mt-2">
                    <Footer />
                </div>
            </div>
             
        </>
    );
}

export default Careers;
